import jwtDecode from 'jwt-decode'
import router from '../../router.js'

/**
 *
 *
 * @param {ModuleBuilderContext} context
 *
 * @return {{mutations: {}, state: {}, getters: {}, actions: {}, namespaced: boolean}}
 */
export default function authentication (context) {
  const {resource, parsed} = context;

  const token = localStorage.getItem('token');
  const initialState = token ? {
    $name: 'authentication',
    $namespace: 'authentication',
    $parentNamespace: '',
    user: jwtDecode(token),
    token,
    selectedCompany: null,
    selectedCompanyId: null,
    companies: []
  } : {
    $name: 'authentication',
    $namespace: 'authentication',
    $parentNamespace: '',
    user: null,
    token: undefined,
    selectedCompany: null,
    selectedCompanyId: null,
    companies: []
  };
  if (initialState.user) {
    initialState.selectedCompanyId = initialState.user.companies[0]
  }
  return {
    namespaced: true,
    state: initialState,
    actions: {
      login({ dispatch, commit }, { username, password } = {}) {
        dispatch('api/fetch', {
          uri: resource.operations.create.url,
          options: {
            method: 'POST',
            // FIXME: build request body from schema.
            body: JSON.stringify({ username, password })
          }}, { root: true })
          .then((response) => {
            return response.json()
          })
          .then(
            body => {
              return body.token
            }
          )
          .then(
            data => {
              dispatch('updateToken', data);
              router.back();
            },
            error => {
              commit('loginFailure', error);
            }
          );
      },
      refresh ({ dispatch, commit }) {
        // FIXME: build request URL.
        dispatch('api/fetch', { uri: '/api/v2/login_refresh' }, { root: true })
          .then((response) => {
            return response.json()
          })
          .then(
            body => {
              return body.token
            }
          )
          .then(
            data => {
              dispatch('updateToken', data);
            },
            error => {
              commit('loginFailure', error);
              dispatch('logout');
            }
          );
      },
      updateToken ({ commit, dispatch, getters, state }, token) {
        commit('loginSuccess', token);
        // FIXME: this is ugly hardcoded stuff.
        if (state.companies.length !== getters.companyIds.length) {
          dispatch('api/fetch', { uri: parsed.company.operations.list.url + '?' + getters.companyIds.map((uuid) => 'uuid[]=' + uuid).join('&')}, { root: true })
            .then((response) => {
              return response.json()
            })
            .then(
              body => {
                commit('companiesUpdated', body['hydra:member']);
              }
            )
        }
      },
      logout ({ commit }) {
        commit('logout');
        if (router.currentRoute.name !== 'LoginPage') {
          router.push({name: 'LoginPage'})
        }
      },
      selectCompany ({commit}, uuid) {
        commit('selectCompany', uuid)
      }
    },
    getters: {
      token: state => state.token,
      userId: state => state.user ? state.user.user_id : undefined,
      id: state => state.user ? state.user['@id'] : undefined,
      username: state => state.user ? state.user.username : undefined,
      name: state => state.user ? state.user.name : undefined,
      expiresAt: state => state.user ? state.user.exp : undefined,
      isMemberOf: (company) => state => (state.user && state.user.companies) ? state.user.companies.indexOf(company) !== -1 : false,
      companyIds: state => (state.user && state.user.companies) ? state.user.companies : [],
      companies: state => (state.user && state.companies) ? state.companies: [],
      selectedCompany: state => {
        for (let index = 0; index < state.companies.length; index++) {
          if (state.companies[index]['uuid'] === state.selectedCompanyId) {
            return state.companies[index]
          }
        }
        return null
      },
      selectedCompanyId: state => state.selectedCompanyId,
    },
    mutations: {
      loginSuccess(state, token) {
        state.user = jwtDecode(token);
        state.token = token;
        if (state.selectedCompanyId === null) {
          state.selectedCompanyId = state.user.companies[0]
        }
        localStorage.setItem('token', token)
      },
      loginFailure(state) {
        state.user = null;
        localStorage.removeItem('token')
      },
      logout(state) {
        state.user = null;
        localStorage.removeItem('token')
      },
      companiesUpdated (state, companies) {
        state.companies = []
        companies.map((company) => {
          state.companies.push(company)
        })
      },
      selectCompany (state, company) {
        state.selectedCompanyId = company
      }
    }
  }
}
